import { ChevronRight } from "lucide-react"

interface Props {
  open: boolean
}

const ToggleChevron: React.FC<Props> = ({ open }) => (
  <ChevronRight
    size={18}
    strokeWidth={3}
    className="text-body-secondary"
    style={{
      transform: open ? "rotate(90deg)" : "rotate(0deg)",
      transition: "transform 0.2s ease",
    }}
  />
)

export default ToggleChevron
